// Core Domain Search Module - Type Definitions

// Configuration Interfaces

// BI Events Interfaces

// API Request/Response Types

// URL Recovery Types

// Constants

export const DEFAULT_STYLES = [{
  id: 'traditional',
  key: 'core_domain_search.domain_gate.style_traditional'
}, {
  id: 'modern',
  key: 'core_domain_search.domain_gate.style_modern'
}, {
  id: 'playful',
  key: 'core_domain_search.domain_gate.style_playful'
}, {
  id: 'upscale',
  key: 'core_domain_search.domain_gate.style_upscale'
}, {
  id: 'professional',
  key: 'core_domain_search.domain_gate.style_professional'
}];
export const DEFAULT_CONFIG = {
  enableUrlRecovery: true,
  enableBusinessInfo: true,
  maxTLDs: 6,
  maxKeywords: 10,
  debounceMs: 300
};
//# sourceMappingURL=types.js.map